import {logoutUser} from "../actions/session";

export function isDev() {
  return process.env.NODE_ENV === 'development';
}

export function checkResponseError(errorObject) {
  return errorObject.apiError === 'SUCCESS'
}

export async function dispatchError(error, onDispatch, dispatch) {
  await (error.message === 'logout-user') ? dispatch(logoutUser()) : dispatch(onDispatch);
}
